import { useShallow } from "zustand/react/shallow";
import ChangeManagementContent from "../changeManagement/USFDA/ChangeManagementContent";
import ChangeManagementInit from "../changeManagement/USFDA/ChangeManagmentInit";
import { useFDAChangeManagementStore } from "../../store/useFDAChangeManagementStore";

export function USChangeTab() {
  const decisionFlow = useFDAChangeManagementStore(
    (state) => state.decisionFlow
  );

  return (
    <>
      {decisionFlow.length === 0 && <ChangeManagementInit />}
      {decisionFlow.length > 0 && <ChangeManagementContent />}
    </>
  );
}
